<!--
 * @Author: zhaoliang
 * @Date: 2024-05-23 16:22:19
 * @LastEditTime: 2025-08-25 14:30:02
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/PrebookSuccess/index.vue
 *
-->
<template>
  <div class="home-page-wrapper">
    <div class="home-page-service">
      <div class="prebook-success">
        <img src="@/components/LeftAccount/images/icon-verifyed.svg" alt="success" />
        <p class="title">{{ $t('prebook-book-success-title') }}</p>
        <p class="desc" v-html="$t('prebook-book-success-desc')"></p>
        <button class="btn" @click="goToTripsDetail">{{ $t('prebook-book-success-btn') }}</button>
      </div>

      <div class="airport-service">
        <!-- Airport Dining Offers -->
        <airport-lounge-card
          :options="dining"
          class="service"
          @viewMore="handleViewMore"
          @cardClick="handleCardClick"
        ></airport-lounge-card>

        <!-- Airport Retail Offers -->
        <airport-lounge-card
          :options="retail"
          class="retail"
          @viewMore="handleViewMore"
          @cardClick="handleCardClick"
        ></airport-lounge-card>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';
  import AirportLoungeCard from '@/components/BaseUi/AirportLoungeCards';
  import { mapState } from 'vuex';

  export default {
    name: 'PrebookSuccess',
    components: {
      AirportLoungeCard,
    },

    computed: {
      ...mapState(['isLogin', 'userInfo']),
    },

    data() {
      return {
        i18n,
        dining: {
          title: 'views-home-sub-tit-Dining',
          subTitle: 'views-home-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '24%',
          },
          cards: [],
          index: 'dining',
        },
        retail: {
          title: 'views-home-sub-tit-Retail',
          subTitle: 'views-home-more',
          showDesc2: true,
          useHomePageSize: true,
          cardItemStyle: {
            width: '24%',
          },
          cards: [],
          index: 'retail',
        },
      };
    },

    mounted() {
      this.getHomePageData();
    },

    methods: {
      // 获取首页权益数据
      getHomePageData() {
        this.$loading.show();
        const data = {
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
        };
        this.$http.common.getHomePageData(data).then(
          res => {
            if (res?.state === '11') {
              this.dining.cards = res.payload.dining.slice(0, 2);
              this.retail.cards = res.payload.retail.slice(0, 2);
              this.$loading.hide();
            } else {
              console.error(res?.note);
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },
      goToTripsDetail() {
        this.$router.push({ name: 'TripsDetail', query: { orderNo: this.$route.query.orderNo } });
      },

      // 卡片的view More被点击
      handleViewMore(data) {
        const dining = data.includes('dining');
        const retail = data.includes('retail');

        if (dining) this.$router.push({ name: 'Dining', params: { type: 2 } });
        if (retail) this.$router.push({ name: 'Retail', params: { type: 3 } });
      },
      // 首页卡片被点击
      handleCardClick(data) {
        if (data.productType === 1) {
          this.$router.push({
            path: '/lounge/details',
            query: { loungeId: data.id, loungeCode: data.code },
          });
        } else if (data.productType === 2) {
          this.$router.push({
            path: '/dining/details',
            query: { diningId: data.id, diningCode: data.code },
          });
        } else if (data.productType === 3) {
          this.$router.push({
            path: '/retail/details',
            query: { airportCode: data.airportCode, retailCodes: data.code },
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile.scss';
</style>
